import { render, staticRenderFns } from "./IconEllipsisVertical.vue?vue&type=template&id=121a7984"
import script from "./IconEllipsisVertical.vue?vue&type=script&lang=js"
export * from "./IconEllipsisVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports